import IComponent from "components/commons/IComponent";
import Button from "@material-ui/core/Button";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import "./PanelBase.scoped.css";
import "./BookmarkManager.scoped.css";
import "./Suggestion.scoped.css";
import { Divider } from "@material-ui/core";
import GetArcGISToken from "utils/GetArcGISToken";

class Suggestion extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      editingSuggestion: {
        Name: undefined,
        Email: undefined,
        ContactNo: "",
        Suggestion: "",
      },
      ShowContactInfo: false,
    };
  }
  componentDidMount() {
    let userGroup = GetArcGISToken.user.userGroup;

    this.setState({
      ShowContactInfo:
        [1, 2, 8].includes(userGroup) && GetArcGISToken.user.iu === "g",
    });
  }
  componentWillUnmount() {}
  async SendMail() {
    console.log(this.state.editingSuggestion);

    try {
      this.props.showDialog({
        isOpen: true,
        title: "Loading",
        content: (
          <div>
            <span className="icn_loading" />
            Sending your email. Please wait...
          </div>
        ),
        onDialogCancel: async () => {},
      });

      let domain = this.$config.webSrvUrl;
      let queryPara = this.state.editingSuggestion;

      // JSON.parse(
      let result = await this.makeHttpQuery(
        domain + this.$config.sendsuggestion,
        "POST",
        JSON.stringify(queryPara),
        true
        // JSON.stringify(queryPara)
      );

      this.props.showDialog({
        isOpen: true,
        title: "Send your email successfully",
        content: <div>Send your email successfully</div>,
        onDialogOk: () => {},
      });

      console.log("check post result", result);
    } catch (e) {
      this.props.showDialog({
        isOpen: true,
        type: "error",
        title: "Failed to send your email",
        jsxElement: e.toString(),
        onDialogOk: () => {},
      });
    }
  }
  render() {
    let { editingSuggestion, ShowContactInfo } = this.state;
    return (
      <div>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>Suggestion / Query</span>

          <div />
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={() => this.props.mapUICallback("hideAllPanel")}
          />
        </div>
        <div className="SubPanelContent PanelContent">
          <div className="SuggestionForm">
            <div>
              <div>* Name</div>
              <EditableDatagridCell
                cellInfo={{
                  colDef: {
                    field: "Name",
                    dataType: "text",
                  },
                  row: editingSuggestion,
                }}
                onChange={(field, value, values) => {
                  this.setState({
                    editingSuggestion: {
                      ...editingSuggestion,
                      [field]: value,
                    },
                  });
                }}
              />
            </div>
            {editingSuggestion.Name !== undefined &&
              editingSuggestion.Name.length <= 0 && (
                <div style={{ color: "red", fontWeight: "bold" }}>
                  <span style={{ float: "right" }}>
                    Please enter the name! The name is mandatory
                  </span>
                </div>
              )}
            <div className="spacer" />
            <div>
              <div>* Lotus Notes / Email</div>
              <EditableDatagridCell
                cellInfo={{
                  colDef: {
                    field: "Email",
                    dataType: "text",
                  },
                  row: editingSuggestion,
                }}
                onChange={(field, value, values) => {
                  this.setState({
                    editingSuggestion: {
                      ...editingSuggestion,
                      [field]: value,
                    },
                  });
                }}
              />
            </div>
            {editingSuggestion.Email !== undefined &&
              editingSuggestion.Email.length <= 0 && (
                <div style={{ color: "red", fontWeight: "bold" }}>
                  <span>Please enter the email! The email is mandatory</span>
                </div>
              )}
            <div className="spacer" />
            <div>
              <div>Contact No.</div>
              <EditableDatagridCell
                cellInfo={{
                  colDef: {
                    field: "ContactNo",
                    dataType: "text",
                  },
                  row: editingSuggestion,
                }}
                onChange={(field, value, values) => {
                  this.setState({
                    editingSuggestion: {
                      ...editingSuggestion,
                      [field]: value,
                    },
                  });
                }}
              />
            </div>
            <div className="spacer" />
            <div>
              <div>Suggestion / Query</div>
              <div>
                <EditableDatagridCell
                  cellInfo={{
                    colDef: {
                      field: "Suggestion",
                      dataType: "text",
                      multiline: true,
                    },
                    row: editingSuggestion,
                  }}
                  onChange={(field, value, values) => {
                    this.setState({
                      editingSuggestion: {
                        ...editingSuggestion,
                        [field]: value,
                      },
                    });
                  }}
                />
              </div>
            </div>
            <div className="spacer" />
            <div>
              <div>* represent a mandatory field</div>
            </div>
            <div className="spacer" />
            <div>
              <div />

              <div className="EqualWidthChildren">
                <div className="AlignRight">
                  <Button
                    variant="outlined"
                    disabled={
                      editingSuggestion.Name === undefined ||
                      editingSuggestion.Email === undefined
                        ? true
                        : !!(
                            editingSuggestion.Name.length < 1 ||
                            editingSuggestion.Email.length < 1
                          )
                        ? true
                        : false
                    }
                    onClick={() => {
                      this.SendMail();
                    }}
                  >
                    <span className="icn_mail" />
                  </Button>
                </div>
              </div>
            </div>
            {ShowContactInfo && (
              <>
                <div className="spacer" />
                <Divider className="divider" />
                <div className="EqualWidthChildren">
                  <div>For any query or comments, please contact:</div>
                </div>
                <div className="EqualWidthChildren">
                  <div>Mr HO Chau Man Richard (GE/ES2) - 2760 5809</div>
                </div>
                <div className="EqualWidthChildren">
                  <div>Mr HO Wai Kit (STO/IT) - 2760 5804</div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Suggestion;
